// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class PatrolDeviceResource extends Resource {
    basePath: string = 'services/providers/providers/{parent}/devices/';

    objectPath: string = 'services/providers/providers/{parent}/devices/{ident}/';
}
